import './index.less';



// WEBPACK FOOTER //
// ./components/slider/style/index.tsx